
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/select-role",
      function () {
        return require("private-next-pages/user/select-role.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/select-role"])
      });
    }
  